import { tsValidateValue } from '@nu-art/ts-common';
import { sectionSortMethods } from './types.js';
export const Validator_SectionSortMethod = tsValidateValue([...sectionSortMethods]);
//# sourceMappingURL=validation.js.map